var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _path, _circle, _rect1, _rect10;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGeneratorDelete(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 94,
    viewBox: "0 0 64 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.75781,
    y: 6.08289,
    width: 41.4844,
    height: 82.9688,
    rx: 2,
    fill: "white",
    stroke: "white",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.9062,
    y: 33.7391,
    width: 4.14844,
    height: 11.0625,
    rx: 1,
    fill: "#D8FFEC"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 18.4375,
    y: 33.7391,
    width: 4.14844,
    height: 11.0625,
    rx: 1,
    fill: "#D8FFEC"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 23.9688,
    y: 33.7391,
    width: 4.14844,
    height: 11.0625,
    rx: 1,
    fill: "#D8FFEC"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 29.5,
    y: 33.7391,
    width: 4.14844,
    height: 11.0625,
    rx: 1,
    fill: "#D8FFEC"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 35.0312,
    y: 33.7391,
    width: 4.14844,
    height: 11.0625,
    rx: 1,
    fill: "#D8FFEC"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 40.5625,
    y: 33.7391,
    width: 4.14844,
    height: 11.0625,
    rx: 1,
    fill: "#D8FFEC"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 10.1406,
    y: 7.4657,
    width: 38.7188,
    height: 69.1406,
    rx: 1,
    fill: "#266ACA"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 21.2031,
    y: 5.70007,
    width: 16.5938,
    height: 5.53125,
    rx: 1,
    fill: "white"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 8.375,
    y: 30.5907,
    width: 42.25,
    height: 20.125,
    stroke: "white",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4754 39.8598L18.0914 40.9818L16.7384 41.4548L18.0914 41.9168L17.4314 43.0828L16.3314 42.1148L16.6064 43.5448H15.3194L15.5834 42.1148L14.4944 43.0938L13.8124 41.9058L15.1654 41.4328L13.8234 40.9928L14.4504 39.8598L15.5944 40.8168L15.3084 39.3648H16.6174L16.3314 40.8168L17.4754 39.8598ZM22.8514 39.8598L23.4674 40.9818L22.1144 41.4548L23.4674 41.9168L22.8074 43.0828L21.7074 42.1148L21.9824 43.5448H20.6954L20.9594 42.1148L19.8704 43.0938L19.1884 41.9058L20.5414 41.4328L19.1994 40.9928L19.8264 39.8598L20.9704 40.8168L20.6844 39.3648H21.9934L21.7074 40.8168L22.8514 39.8598ZM28.2274 39.8598L28.8434 40.9818L27.4904 41.4548L28.8434 41.9168L28.1834 43.0828L27.0834 42.1148L27.3584 43.5448H26.0714L26.3354 42.1148L25.2464 43.0938L24.5644 41.9058L25.9174 41.4328L24.5754 40.9928L25.2024 39.8598L26.3464 40.8168L26.0604 39.3648H27.3694L27.0834 40.8168L28.2274 39.8598ZM33.6033 39.8598L34.2193 40.9818L32.8663 41.4548L34.2193 41.9168L33.5593 43.0828L32.4593 42.1148L32.7343 43.5448H31.4473L31.7113 42.1148L30.6223 43.0938L29.9403 41.9058L31.2933 41.4328L29.9513 40.9928L30.5783 39.8598L31.7223 40.8168L31.4363 39.3648H32.7453L32.4593 40.8168L33.6033 39.8598ZM38.9793 39.8598L39.5953 40.9818L38.2423 41.4548L39.5953 41.9168L38.9353 43.0828L37.8353 42.1148L38.1103 43.5448H36.8233L37.0873 42.1148L35.9983 43.0938L35.3163 41.9058L36.6693 41.4328L35.3273 40.9928L35.9543 39.8598L37.0983 40.8168L36.8123 39.3648H38.1213L37.8353 40.8168L38.9793 39.8598ZM44.3553 39.8598L44.9713 40.9818L43.6183 41.4548L44.9713 41.9168L44.3113 43.0828L43.2113 42.1148L43.4863 43.5448H42.1993L42.4633 42.1148L41.3743 43.0938L40.6923 41.9058L42.0453 41.4328L40.7033 40.9928L41.3303 39.8598L42.4743 40.8168L42.1883 39.3648H43.4973L43.2113 40.8168L44.3553 39.8598Z",
    fill: "#2EA76D"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50.5,
    cy: 58.5,
    r: 13.5,
    fill: "#D0021B"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 46.1633,
    y: 65.9032,
    width: 2.9299,
    height: 16.6028,
    rx: 1,
    transform: "rotate(-135 46.1633 65.9032)",
    fill: "white"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 44.0916,
    y: 54.1633,
    width: 2.9299,
    height: 16.6028,
    rx: 1,
    transform: "rotate(-45 44.0916 54.1633)",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneratorDelete);
export default __webpack_public_path__ + "static/media/generator-delete.9be2423a480b01f0c5b2ec3e85cf0bc9.svg";
export { ForwardRef as ReactComponent };